// extracted by mini-css-extract-plugin
module.exports = {"swatch":"styles_swatch__vgyV9","color":"styles_color__3rH0E","popover":"styles_popover__1cTCv","cover":"styles_cover__3mPEZ"};